module.exports = __webpack_public_path__ + "static/media/step4.bae97ede.png";